function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "2"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 8585",
  d: "M7 2H1a1 1 0 010-2h6a1 1 0 010 2z",
  fill: "#51bb7b"
})));